/** Stored percentages remain the total increase, including VAT, for backwards compatibility. */
export const PRICING_VAT_PERCENT = 17;

/** Four decimals are for display only. Never rewrite stored values while rendering. */
export function marginDisplay(totalMarkup: unknown): string {
  if (totalMarkup === null || totalMarkup === undefined || totalMarkup === '') return '';
  const total = Number(totalMarkup);
  if (!Number.isFinite(total)) return '';
  return (((1 + total / 100) / (1 + PRICING_VAT_PERCENT / 100) - 1) * 100).toFixed(4);
}

/** Keep the exact original when an unchanged, rounded display value is submitted. */
export function markupFromMarginInput(input: string, previousTotal: unknown): number | null {
  if (input.trim() === '') return null;
  const margin = Number(input);
  const previous = Number(previousTotal);
  if (!Number.isFinite(margin)) return Number.isFinite(previous) ? previous : null;
  if (previousTotal != null && previousTotal !== '' && margin === Number(marginDisplay(previousTotal))) return previous;
  return Number((((1 + margin / 100) * (1 + PRICING_VAT_PERCENT / 100) - 1) * 100).toFixed(12));
}

/** Custom price bases use a literal adjustment, not a net-cost margin. */
export function usesPriceAdjustment(rule: { costPriceColumn?: string }): boolean {
  return !!rule.costPriceColumn && rule.costPriceColumn !== 'nabavna_cijena';
}
export function pricingInputDisplay(value: unknown, adjustment = false): string {
  if (!adjustment) return marginDisplay(value);
  return value == null || value === '' || !Number.isFinite(Number(value)) ? '' : String(Number(value));
}
export function pricingInputValue(input: string, previous: unknown, adjustment = false): number | null {
  if (!adjustment) return markupFromMarginInput(input, previous);
  if (input.trim() === '') return null;
  return Number.isFinite(Number(input)) ? Number(input) : (previous == null ? null : Number(previous));
}
